import React from 'react';
import _ from 'underscore';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Button, Grid, Divider, Segment, Header, Input, Dimmer, Loader, Message } from 'semantic-ui-react';
import moment from 'moment'

import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
import FormsInputsEmail from '../../../forms/inputs/email/forms_inputs_email';
import FormsInputDropdown from '../../../forms/inputs/dropdown';
import CommonUtility from '../../../../utils/CommonUtility';
import { USER_TYPE, USER_ROLES } from '../../../../constants';

const statusLetterOptions = [
    { text: 'Registered', value: 100 },
    { text: 'Not Registered', value: 101 },
    { text: 'Locked', value: 300 },
    { text: 'Suspended', value: 301 },
    { text: 'Terminated', value: 401 }
];

const yesNoOptions = [
    { text: 'Yes', value: true },
    { text: 'No', value: false },
]

class UserFormLoginInformation extends React.Component {

    render() {
        const { user, company } = this.props;
        const isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.admin);
        const isAdminCallCentre = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_CALL_CENTRE], this.props.admin);

        return (
            <Formik
                initialValues={{
                    userId: user.uuid,
                    email: user.email,
                    status: user.status,
                    registrationDate: user.registrationDate ? moment(user.registrationDate).format('YYYY-MM-DD HH:mm') : '',
                    lastLogin: user.lastLogin ? moment(user.lastLogin).format('YYYY-MM-DD HH:mm') : '',
                    lastPasswordUpdate: user.lastPasswordUpdate ? moment(user.lastPasswordUpdate).format('YYYY-MM-DD HH:mm') : '',
                    passwordLoginAttempt: !user.passwordLoginAttempt ? [] : user.passwordLoginAttempt.map( loginAttemp =>  moment(loginAttemp).format('YYYY-MM-DD HH:mm')),
                    onboardingEmailSent: user.onboardingEmailSent,
                    pin_number: user.pin_number || ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={this.props.onSubmit}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => {

                    // Show loading UI
                    if(isSubmitting){
                        return ( <Dimmer active inverted><Loader>Loading</Loader></Dimmer>)
                    }

                    return (
                        <Form>
                            <Segment>
                                <Grid container columns={1}>
                                    <Grid.Column width={16}>
                                        <Divider horizontal style={{ margin: "13px 0 0 0" }}> <Header as='h3'>Login Information</Header></Divider>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="email" label="Email" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    {this.props.showDetail &&
                                        <>
                                            <Grid.Column>
                                                <Field name="status" label="Status" component={FormsInputDropdown} secondaryLabel="" options={statusLetterOptions} disabled={!isAdminOperation && !isAdminCallCentre} />
                                            </Grid.Column>

                                            <Grid.Column width={16} style={{ margin: "40px 0 -25px 0"}}>
                                                <Divider horizontal> <Header as='h3'>Email Sent</Header></Divider>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="onboardingEmailSent" label="Welcome Email Sent" component={FormsInputDropdown} options={yesNoOptions} disabled={!isAdminOperation} />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="pin_number" label="PIN Number" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>

                                            <Grid.Column width={16} style={{ margin: "60px 0 -25px 0"}}>
                                                <Divider horizontal> <Header as='h3'>System Generated Data</Header></Divider>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="registrationDate" label="Registration Date" type="datetime" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="lastLogin" label="Last Login" type="datetime" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                            {Array.isArray(values.passwordLoginAttempt) &&
                                                <Grid.Column>
                                                    <Header as='h5'>Last Known Login Failed</Header>
                                                    {values.passwordLoginAttempt.length > 0 && values.passwordLoginAttempt.map( (loginAttemp, indexLoginAttemp) => (
                                                        <Input fluid key={indexLoginAttemp} type="datetime" value={loginAttemp} disabled={true}/>
                                                    ))}
                                                    {values.passwordLoginAttempt.length <= 0 && 
                                                        <Input fluid type="text" disabled={true}/>
                                                    }
                                                </Grid.Column>
                                            }
                                            <Grid.Column>
                                                <Field name="lastPasswordUpdate" label="Last Password Update" type="datetime" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                        </>
                                    }

                                    {(isAdminOperation || isAdminCallCentre) &&
                                        <Grid.Column width={16}>
                                            <Button
                                                loading={isSubmitting}
                                                type="submit"
                                                primary
                                                disabled={isSubmitting}
                                                fluid
                                                size="big"
                                            >
                                                {this.props.submitText}
                                            </Button>
                                        </Grid.Column>
                                    }

                                    {(isAdminOperation || isAdminCallCentre) && this.props.showDetail &&
                                        <Grid.Column width={16}>
                                            <Button
                                                type="button"
                                                color="teal"
                                                loading={this.props.pinCodeLoading}
                                                disabled={this.props.pinCodeLoading}
                                                onClick={() => this.props.onResendPinCode(values.email)}
                                                fluid
                                                size="big"
                                            >
                                                Resend 6-Digit Code
                                            </Button>
                                        </Grid.Column>
                                    }

                                    {this.props.pinCode &&
                                        <Grid.Column width={16}>
                                            <Message info>
                                                <Message.Header>6-Digit Code Generated</Message.Header>
                                            </Message>
                                        </Grid.Column>
                                    }

                                    <Grid.Column width={16}>
                                        {this.props.renderSubmitResult instanceof Function && this.props.renderSubmitResult()}
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                        </Form>
                    )
                }}
            >
            </Formik>
        );

    }

}

UserFormLoginInformation.defaultProps = {
    user: {},
    admin: {},
    onSubmit: undefined,
    renderSubmitResult: undefined,
    submitText: "Save",
    onResendPinCode: undefined,
    pinCode: null,
    pinCodeLoading: false,
}

export default UserFormLoginInformation;